<template>
    <div>
        <ybDuiZhang />
    </div>
</template>

<script>
import ybDuiZhang from "./ybDuiZhangView.vue";
export default {
    components: {
        ybDuiZhang,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
